export enum DownloadStatus {
  Idle = 'idle',
  Running = 'running',
  Success = 'success',
  Error = 'error'
}

export type DownloadStatusLabels = Partial<Record<DownloadStatus, string>>;

export interface DownloadButtonIcons {
  idle?: string;
  running?: string;
  success?: string;
  error?: string;
}
